/** Shared name-derived tags for model dialogs and import previews.
 * Keep the established punctuation, word limit and numeric suffix rules.
 */
export function tagFromName(name: string, maxTagCharacters: number, tags?: readonly string[]): string {
  let tag = "";
  const parts = name
    .replaceAll(/[/-]/g, " ")
    .replaceAll(/[^a-zA-Z0-9 ]/g, "")
    .split(" ");
  let numberFromName = -1;
  for (const [index, part] of parts.entries()) {
    if (index === parts.length - 1 && /^\d+$/.test(part)) {
      numberFromName = parseInt(part);
    } else if (index + 1 <= maxTagCharacters) {
      tag += part.substring(0, 1);
    }
  }
  if (tags) {
    const originalTag = tag;
    let index = numberFromName > -1 ? numberFromName : 1;
    tag = `${tag}${numberFromName !== -1 ? numberFromName : ""}`;
    while (tags.includes(tag.toLocaleUpperCase())) tag = `${originalTag}${index++}`;
  }
  return tag.toUpperCase();
}
